import { ApiRequestService } from 'services/ApiRequestService';

export const BillingService = {
    generateToken(transactionId) {
        return ApiRequestService.post('billing', `Transactions/${encodeURIComponent(transactionId)}/GenerateToken`);
    }
};
